import { Link } from 'react-router-dom'
import { t, Trans } from '@lingui/macro'

import Button from '@mui/material/Button'
import Container from '@mui/material/Container'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import WhaleImg from '@/assets/img/whale.png'

export function UnknownError() {
  return (
    <Container maxWidth="sm" sx={{ height: '100%' }} data-testid="error-boundary-fallback">
      <Stack height="100%" alignItems="center" justifyContent="center" spacing={2}>
        <img src={WhaleImg} alt="unexpected-error" width="100%" />
        <Typography component="h1" color="primary" fontSize={36} fontWeight={700} textAlign="center">
          <Trans>Unexpected error! Something went wrong.</Trans>
        </Typography>
        <Button component={Link} to="/" variant="contained">
          <Trans>Back to home page</Trans>
        </Button>
      </Stack>
    </Container>
  )
}

export default UnknownError
